import React from 'react';
import './LearningStyle.css';

const ClassCard = ({ data }) => {
  return (
    <div className="class-card">
      <h3 className="class-card-title">{data.title}</h3>
      <div className="class-card-details">
        {data.details.map((detail, index) => (
          <div className="detail-row" key={index}>
            <p className="detail-label">{detail.label}</p>
            <p className="detail-value">{detail.value}</p>
          </div>
        ))}
      </div>
      <button className="buy-course-button">
        {/* <img src="/lovable-uploads/12b1ce1d-0344-4740-808f-5d91c38cf39e.png" alt="Flower icon" className="button-icon" /> */}
        Buy Course
      </button>
    </div>
  );
};

const LearningStyle = () => {
  const privateClassData = {
    title: "Private 1-on-1 Class",
    details: [
      { label: "Class duration", value: "60 minutes" },
      { label: "Class type", value: "Individual" },
      { label: "Class schedule", value: "Flexible" },
      { label: "Learning mode", value: "With teacher" },
      { label: "Pace of learning", value: "Personalized" },
      { label: "Activities", value: "With teacher" },
      { label: "Assessment", value: "Individual" },
    ]
  };

  const groupClassData = {
    title: "Group Classes",
    details: [
      { label: "Class duration", value: "60 minutes" },
      { label: "Class type", value: "Small Group" },
      { label: "Class schedule", value: "Peer dependent" },
      { label: "Learning mode", value: "With teacher and fellow Polymaths" },
      { label: "Pace of learning", value: "Group" },
      { label: "Activities", value: "With teacher and fellow Polymaths" },
      { label: "Assessment", value: "Individual and as a team" },
    ]
  };

  return (
    <div className="learning-style-container">
      <h2 className="learning-style-heading">
        Choose the learning style that <span>suits your child best</span>
      </h2>
      <div className="learning-style-cards">
        <ClassCard data={privateClassData} />
        <ClassCard data={groupClassData} />
      </div>
    </div>
  );
};

export default LearningStyle;